import { EventEmitter } from "@angular/core";

export const calculateForecastMeasures = (
  fieldCode: any,
  column: any,
  calculateMeasures: EventEmitter<any>
) => {
  const model = {
    fieldCode,
    column,
  };
  calculateMeasures.emit(model);
};
